//积分管理
const RouteTemp = () => import(/*webpackChunkName:'sale'*/'@/page/commons/routeTemp.vue')
const PointsRule=()=>import(/*webpackChunkName:'sale'*/'@/page/sale/points-management/points-rule/points-rule.vue')
// const PointsRedemptionRule=()=>import(/*webpackChunkName:'sale'*/'@/page/sale/points-management/points-redemption-rule/points-redemption-rule.vue')
const PointsUsedRecord=()=>import(/*webpackChunkName:'sale'*/'@/page/sale/points-management/points-used-record/points-used-record.vue')
export  const pointsManagement={
        path: '/main/points',
        name: '积分管理',
        meta: {
            requireAuth: true,
        },
        component: RouteTemp,
        children: [{
            path: '/main/points/rule',
            name: '积分规则',
            meta: {
                requireAuth: true,
            },
            component: PointsRule
        },
        // {
        //     path: '/main/points/redemption-rule',
        //     name: '积分兑换规则',
        //     meta: {
        //         requireAuth: true,
        //     },
        //     component: PointsRedemptionRule
        // },
        {
            path: '/main/points/used-record',
            name: '积分记录',
            meta: {
                requireAuth: true,
            },
            component: PointsUsedRecord
        },
       ]
    }